import React from 'react';
import { RefreshCw, DollarSign, Smartphone, Tag, ShoppingCart, BarChart2, Upload, Battery, QrCode } from 'lucide-react';
import img1 from '../components/images/esl/1.jpg_large'
import img2 from '../components/images/esl/banner esl.png'
import ProductShowcase from './ProductShowcase';

const HanshowESL = () => {
  // Sample product data
  const products = [
    { id: 1, name: 'Stellar Series', desc: 'High-resolution e-ink for premium retail', image: '/api/placeholder/300/200' },
    { id: 2, name: 'Nebular Series', desc: 'Color e-ink for promotions', image: '/api/placeholder/300/200' },
    { id: 3, name: 'Galaxy Series', desc: 'Basic ESL for supermarkets', image: '/api/placeholder/300/200' },
    { id: 4, name: 'Pulsar NFC', desc: 'NFC-enabled interactive labels', image: '/api/placeholder/300/200' },
  ];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section>
        <div className="w-full h-full relative">
      <img
        src={img2}
        alt="Banner"
        className="w-full h-full object-cover"
      />
      {/* Optional overlay text */}
      
    </div>
      </section>
      {/* <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="space-y-6">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                  Revolutionize Your Retail with 
                  <span className="bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent"> Hanshow</span> ESL
                </h1>
                <p className="text-xl text-blue-100 leading-relaxed max-w-2xl">
                  Dynamic pricing, real-time updates, and operational efficiency — all in one smart label.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="px-8 py-4 bg-white text-blue-900 font-semibold rounded-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-200 shadow-lg">
                  Request a Demo
                </button>
                <button className="px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-blue-900 transition-all duration-200">
                  Get a Quote
                </button>
              </div>
            </div>
            <div className="relative">
              <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500">
                <img 
                  src={img1}
                  alt="Hanshow ESL in retail environment" 
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-tr from-yellow-400/20 to-orange-500/20 rounded-2xl blur-xl"></div>
            </div>
          </div>
        </div>
      </section> */}

      {/* What is Hanshow ESL */}
      <section className="py-20 bg-gray-50 font-poppins">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">What is Hanshow ESL?</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Digital price tags transforming retail operations</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <RefreshCw className="w-10 h-10 text-white" />
              </div>
              <h4 className="text-xl font-semibold mb-3 text-gray-900">Real-time Updates</h4>
              <p className="text-gray-600 leading-relaxed">Change prices instantly across all stores from a central system</p>
            </div>
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <DollarSign className="w-10 h-10 text-white" />
              </div>
              <h4 className="text-xl font-semibold mb-3 text-gray-900">Energy Efficient</h4>
              <p className="text-gray-600 leading-relaxed">E-ink technology uses power only when changing display</p>
            </div>
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <Smartphone className="w-10 h-10 text-white" />
              </div>
              <h4 className="text-xl font-semibold mb-3 text-gray-900">Cloud Management</h4>
              <p className="text-gray-600 leading-relaxed">Control your entire ESL network from anywhere</p>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section className="py-20 bg-white font-poppins">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Key Features</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Everything you need for modern retail pricing</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="p-6 bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <Tag className="w-6 h-6 text-blue-600" />
                </div>
                <h5 className="text-lg font-semibold text-gray-900">Responsive Pricing</h5>
              </div>
              <p className="text-gray-600 leading-relaxed">React instantly to market changes, promotions, or demand fluctuations with price updates in seconds.</p>
            </div>
            <div className="p-6 bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                  <Upload className="w-6 h-6 text-green-600" />
                </div>
                <h5 className="text-lg font-semibold text-gray-900">POS/ERP Integration</h5>
              </div>
              <p className="text-gray-600 leading-relaxed">Seamless connection with your existing retail systems for automatic price synchronization.</p>
            </div>
            <div className="p-6 bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                  <ShoppingCart className="w-6 h-6 text-purple-600" />
                </div>
                <h5 className="text-lg font-semibold text-gray-900">Multiple Sizes</h5>
              </div>
              <p className="text-gray-600 leading-relaxed">Variety of display sizes to fit any product, from small cosmetics to large shelf-edge labels.</p>
            </div>
            <div className="p-6 bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
                  <QrCode className="w-6 h-6 text-orange-600" />
                </div>
                <h5 className="text-lg font-semibold text-gray-900">NFC/QR Enabled</h5>
              </div>
              <p className="text-gray-600 leading-relaxed">Interactive labels that connect with customer smartphones for enhanced shopping experiences.</p>
            </div>
            <div className="p-6 bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mr-4">
                  <Battery className="w-6 h-6 text-yellow-600" />
                </div>
                <h5 className="text-lg font-semibold text-gray-900">5+ Year Battery</h5>
              </div>
              <p className="text-gray-600 leading-relaxed">Ultra-low power consumption means years of maintenance-free operation.</p>
            </div>
            <div className="p-6 bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mr-4">
                  <BarChart2 className="w-6 h-6 text-indigo-600" />
                </div>
                <h5 className="text-lg font-semibold text-gray-900">Cloud Management</h5>
              </div>
              <p className="text-gray-600 leading-relaxed">Centralized dashboard to control thousands of labels across multiple locations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gray-50 font-poppins">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Benefits for Retailers</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Transform your retail operations with digital shelf labels</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 text-center group">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <DollarSign className="w-8 h-8 text-white" />
              </div>
              <h5 className="text-xl font-semibold mb-3 text-gray-900">Reduce Labor Costs</h5>
              <p className="text-gray-600 leading-relaxed">Eliminate manual price tag changes saving hundreds of labor hours annually.</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 text-center group">
              <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <Tag className="w-8 h-8 text-white" />
              </div>
              <h5 className="text-xl font-semibold mb-3 text-gray-900">Eliminate Pricing Errors</h5>
              <p className="text-gray-600 leading-relaxed">Ensure 100% accuracy between shelf prices and POS system.</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 text-center group">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <ShoppingCart className="w-8 h-8 text-white" />
              </div>
              <h5 className="text-xl font-semibold mb-3 text-gray-900">Improve Customer Experience</h5>
              <p className="text-gray-600 leading-relaxed">Dynamic displays with promotions and product info enhance shopping.</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 text-center group">
              <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <RefreshCw className="w-8 h-8 text-white" />
              </div>
              <h5 className="text-xl font-semibold mb-3 text-gray-900">Dynamic Promotions</h5>
              <p className="text-gray-600 leading-relaxed">Run flash sales and time-sensitive promotions with instant shelf updates.</p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <ProductShowcase/>
      </section>
     

      {/* How It Works */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-blue-900 to-blue-800 text-white font-poppins">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">How It Works</h2>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">Simple integration, powerful results</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="group">
              <div className="w-20 h-20 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold text-gray-900 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                1
              </div>
              <h4 className="text-xl font-semibold mb-3">Integrate with POS</h4>
              <p className="text-blue-100 leading-relaxed">Connect Hanshow system with your existing point-of-sale or ERP</p>
            </div>
            <div className="group">
              <div className="w-20 h-20 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold text-gray-900 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                2
              </div>
              <h4 className="text-xl font-semibold mb-3">Update Prices</h4>
              <p className="text-blue-100 leading-relaxed">Make changes through the cloud-based management dashboard</p>
            </div>
            <div className="group">
              <div className="w-20 h-20 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold text-gray-900 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                3
              </div>
              <h4 className="text-xl font-semibold mb-3">Instant Display</h4>
              <p className="text-blue-100 leading-relaxed">Labels update automatically within seconds across all locations</p>
            </div>
          </div>
        </div>
      </section>

      

      {/* Why Choose Us */}
      <section className="py-20 bg-gray-50 font-poppins">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Why Choose Thirdstep Trading Est.</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Your trusted Hanshow ESL partner in the region</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200">
              <h4 className="text-xl font-semibold text-blue-600 mb-4">Expert Implementation</h4>
              <p className="text-gray-600 leading-relaxed">Our certified technicians ensure seamless integration with your existing retail systems.</p>
            </div>
            <div className="p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200">
              <h4 className="text-xl font-semibold text-blue-600 mb-4">Local Support</h4>
              <p className="text-gray-600 leading-relaxed">Dedicated regional support team for installation, training, and maintenance.</p>
            </div>
            <div className="p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200">
              <h4 className="text-xl font-semibold text-blue-600 mb-4">Custom Solutions</h4>
              <p className="text-gray-600 leading-relaxed">Tailored ESL configurations to match your specific retail environment and needs.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* <section className="py-20 bg-gradient-to-r from-gray-900 to-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="mb-8 lg:mb-0 lg:mr-8">
              <h3 className="text-3xl md:text-4xl font-bold mb-4">Ready to transform your retail pricing?</h3>
              <p className="text-xl text-gray-300">Contact our ESL specialists today to discuss your requirements</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="px-8 py-4 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-200 shadow-lg">
                Get a Quote
              </button>
              <button className="px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-gray-900 transition-all duration-200">
                Contact Sales
              </button>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default HanshowESL;